import { render, staticRenderFns } from "./ModalLogout.vue?vue&type=template&id=b17c96f2&scoped=true&"
import script from "./ModalLogout.vue?vue&type=script&lang=js&"
export * from "./ModalLogout.vue?vue&type=script&lang=js&"
import style0 from "./ModalLogout.vue?vue&type=style&index=0&id=b17c96f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17c96f2",
  null
  
)

export default component.exports